import React from 'react';
import MediaBar from './MediaBar';
import MediaDoughnut from './MediaDoughnut';

import styles from './MediaType.module.css';

const MediaType = (props) => {
  return (
    <div className={styles.mediaTypeContainer}>
      <h2>media type:</h2>
      <div className={styles.barDiv}>
        <MediaBar mediaTypeArray={props.mediaTypeArray} />
      </div>
      <div className={styles.doughnutDiv}>
        <MediaDoughnut mediaTypeArray={props.mediaTypeArray} />
      </div>
    </div>
  );
};

export default MediaType;
